export const IMAGE_BASE_URL = 'https://acquaforteapi.omakaweb.com';
export const API_BASE_URL = 'https://acquaforteapi.omakaweb.com';
// export const IMAGE_BASE_URL = 'http://localhost:3307';
// export const API_BASE_URL = 'http://localhost:3307';

// const host = 'https://acquaforteapi.facudev.fr';
